import { h } from '@stencil/core';
export class SkeletonComponent {
  render() {
    const arr = [1, 2, 3, 4];
    return (h("ul", { class: "o-vertical-spacing o-vertical-spacing--l" }, arr.map(() => (h("li", { class: "blog-post o-media" }, h("div", { class: "o-media__figure" }, h("span", { style: { width: '100px', height: '80px' } })), h("div", { class: "o-media__body" }, h("div", { class: "o-vertical-spacing" }, h("h3", null, h("span", { style: { width: '55%' } })), h("p", null, h("span", { style: { width: '80%' } }), h("span", { style: { width: '90%' } }), h("span", { style: { width: '83%' } }), h("span", { style: { width: '80%' } })), h("div", { class: "meta" }, h("span", { style: { width: '70px' } })))))))));
  }
  static get is() { return "pdp-skeleton"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["skeleton.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["skeleton.css"]
    };
  }
}
